/*** IMPORTS FROM imports-loader ***/
var APIURL = "";

import reqwest from 'reqwest'
import util from './util'
// pd与pkid
import ucon from '../util/constant'
import codemapper from '../util/codemapper'
const SMAPIMAP = {
  '/ini': '/dl/zj/mail/ini',
  '/vfcp': '/dl/zj/mail/vfcp',
  '/vftcp': '/dl/zj/mail/vftcp',
  '/vfccp': '/dl/zj/mail/vfccp',
  '/vfscp': '/dl/zj/mail/vfscp',
  '/gt': '/dl/zj/mail/gt',
  '/l': '/dl/zj/mail/l',
  '/powGetP': '/dl/zj/mail/powGetP'
}
const f = function () {}
const DEFAULTTIME = 10000
const CROSS = false
const WITHCRED = false
const CHANNEL = '0'

const pd = ucon.product
const pkid = ucon.promark
const opd = util.getUrlSearch('product')
const reqProxy = function (options) {
  let _host = '/dl'
  let error = options.error || f
  let success = options.success || f
  let complete = options.complete || f
  let method = options.method || 'POST'
  let contentType = options.contentType || 'application/json'
  let data = options.data || {}
  let _url = _host + options.url || ''
  // 后端需要统一加topURL参数（referrer）
  if (document.referrer) {
    data.topURL = document.referrer.slice(0, 200)
  }
  window.$RTID = util.getRtid();
  // 统一加上pd pkid opd参数
  data.pd = pd
  data.pkid = pkid
  data.opd = opd
  data.rtid = window.$RTID
  data.channel = CHANNEL
  if (window.$NEEDV6 && options.url === '/l') {
    data.v6 = 1
  }
  if (util.getSmState() && SMAPIMAP[options.url]) {
    method = 'POST'
    contentType = 'application/json'
    data = JSON.stringify(data)
    data = util.doSm4(data)
    _url = SMAPIMAP[options.url]
  }
  if (method.toUpperCase() === 'POST' && contentType === 'application/json') {
    data = JSON.stringify(data)
  }

  // @NEW 检查离线日志utid是否存在
  let utid = util.getUtid()
  // 初始化请求则追加离线日志请求
  if (options.url === '/ini') {
    util._doFlLog(utid, window.$RTID)
  }

  let ajax = reqwest({
    timeout: options.timeout || DEFAULTTIME,
    url: _url,
    method: method,
    crossOrigin: options.crossOrigin || CROSS,
    withCredentials: options.withCredentials || WITHCRED,
    contentType: contentType,
    data: data,
    complete: complete,
    type: options.type || 'json'
  }).then((_res) => {
    if (_res.ret === '200' || _res.ret === '201') {
      success(_res)
    } else {
      error(_res)
    }
  }).fail(function (res) {
    // 超时、其他请求错误统一返回码-1
    let code = 'httpcode-1'
    let status
    if (res && res.status) {
      status = res.status + ''
      if (['400', '404', '500', '502', '503', '429'].indexOf(status) > -1) {
        code = 'httpcode-' + status
      } else {
        if (status.indexOf('4') === 0) {
          code = 'httpcode-4xx'
        }
        if (status.indexOf('5') === 0) {
          code = 'httpcode-5xx'
        }
      }
    }
    res.ret = code
    if (options.url === '/powGetP') {
      // 算力接口异常不提示
    } else {
      window.showError(codemapper[code])
    }
    error(res)
  }).always(function (_res) {

  })
  return ajax
}

export default reqProxy




// WEBPACK FOOTER //
// ./src/util/request.js